import { useState } from "react";
import { updateCart } from "../../actions";
import { postApi } from "../../ApiServices/api";
import { apiEndPoints } from "../../ApiServices/config";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

function useOrderDetailsData() {
  const [processing, setProcessing] = useState(false);
  const [orderDetails, setOrderDetails] = useState(null);
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const getOrderDetails = async (paymnetId) => {
    try {
      const response = await postApi(apiEndPoints.getPaymentDetails, {
        paymentId: paymnetId,
      });
      console.log("response :- ", response);
      const payment_status = response.data[0].payment_status;
      console.log("payment_status :- ", payment_status);
      if (payment_status !== "SUCCESS") {
        setProcessing(true);
        setOrderDetails(response.data[0]);
        setTimeout(getOrderDetails, 3000);
        console.log("response.data.data :- ", response.data[0]);
      } else {
        setProcessing(false);
        setOrderDetails(response.data[0]);
        dispatch(updateCart());
        console.log("response.data.data 11 :- ", response.data[0]);
      }
    } catch (error) {
      console.error("Error fetching order details:", error);
    }
  };

  return {
    orderDetails,
    processing,
    searchParams,
    navigate,
    getOrderDetails,
  };
}

export default useOrderDetailsData;
